// extracted by mini-css-extract-plugin
export default {"privacySection":"Privacy_privacySection__gtk-+","container":"Privacy_container__IgFvN","content":"Privacy_content__UqYpW","contact":"Privacy_contact__AT3bm"};